/**
 * @generated SignedSource<<f1a175a0a9cb89756ac31e431cfd76d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTaskId_brandMessagePreviewQuery$variables = {
  query?: string | null;
  templateId: string;
};
export type BrandMessageTaskId_brandMessagePreviewQuery$data = {
  readonly brandMessagePreview: {
    readonly targetCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"BrandMessagePreview_brandMessagePreview">;
  };
};
export type BrandMessageTaskId_brandMessagePreviewQuery = {
  response: BrandMessageTaskId_brandMessagePreviewQuery$data;
  variables: BrandMessageTaskId_brandMessagePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "templateId",
    "variableName": "templateId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkMobile",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkIos",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTaskId_brandMessagePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BrandMessagePreview",
        "kind": "LinkedField",
        "name": "brandMessagePreview",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessagePreview_brandMessagePreview"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BrandMessageTaskId_brandMessagePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BrandMessagePreview",
        "kind": "LinkedField",
        "name": "brandMessagePreview",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageMessage",
            "kind": "LinkedField",
            "name": "messages",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "to",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatBubbleType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "header",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "additionalContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "carousel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wideItemList",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "video",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commerce",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandMessageMessageButton",
                "kind": "LinkedField",
                "name": "buttons",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkType",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandMessageMessageCoupon",
                "kind": "LinkedField",
                "name": "coupon",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkPc",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkAndroid",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11ec13a181daa3448dd23284bc08ff5f",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTaskId_brandMessagePreviewQuery",
    "operationKind": "query",
    "text": "query BrandMessageTaskId_brandMessagePreviewQuery(\n  $templateId: ID!\n  $query: String = null\n) {\n  brandMessagePreview(templateId: $templateId, query: $query) {\n    targetCount\n    ...BrandMessagePreview_brandMessagePreview\n  }\n}\n\nfragment BrandMessagePreview_brandMessagePreview on BrandMessagePreview {\n  messages {\n    to\n    chatBubbleType\n    imageUrl\n    imageLink\n    content\n    header\n    additionalContent\n    carousel\n    wideItemList\n    video\n    commerce\n    buttons {\n      name\n      linkType\n      linkMobile\n      linkIos\n    }\n    coupon {\n      title\n      description\n      linkMobile\n      linkPc\n      linkAndroid\n      linkIos\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44e853a32fa164acfcbb84b376479907";

export default node;
